import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable, Subscription } from "rxjs";
import { DatosCreacionBhe } from "src/app/models/BoletaHonorarios/DatosCreacionBhe";
import { DetalleBoletaHonorarios } from "src/app/models/BoletaHonorarios/DetalleBoletaHonorarios";
import { ResumenDetallesBhe } from "src/app/models/BoletaHonorarios/ResumenDetallesBhe";
import { EmisionBheService } from "src/app/services/emision-bhe.service";
import { environment } from "src/environments/environment";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';
@Component({
	selector: "app-prestaciones-bhe",
	templateUrl: "./prestaciones-bhe.component.html",
	styleUrls: ["./prestaciones-bhe.component.scss"],
})
export class PrestacionesBheComponent implements OnInit {
	public prestacionesForm: FormGroup;
	public prestacionesArray: FormArray;
	private detallesBhe: DetalleBoletaHonorarios[] = [];
	private resumenBhe: ResumenDetallesBhe = new ResumenDetallesBhe();
	@Output() public prestacionesEmitter: EventEmitter<any> = new EventEmitter<any>();
	public totalBruto: number = 0;
	public montoRetencion: number = 0;
	public liquido: number = 0;
	private datosReceptor$: Observable<DatosCreacionBhe>;
	private currentBheDatos: DatosCreacionBhe;
	private subs: Subscription[] = [];
	public porcentajeRetencion: number; // Variable para guardar el porcentaje de retención.
	constructor(private formBuilder: FormBuilder, private emisionBheService: EmisionBheService,private sessionUserService: SessionUserService) {
		this.setPrestacionesArray();
		this.datosReceptor$ = this.emisionBheService.datosReceptorObservable;
	}

	ngOnInit(): void {
		this.sessionUserService.verificarSesionUsuario();
		this.porcentajeRetencion = this.getTaxesBhe(2023);
		const sub = this.datosReceptor$.subscribe((datos) => {
			this.currentBheDatos = datos;
			this.onSubmit();
		});
		this.subs.push(sub);
	}

	setPrestacionesArray() {
		this.prestacionesForm = this.formBuilder.group({
			prestaciones: this.formBuilder.array([this.newPrestacionForm()]),
		});
	}
	newPrestacionForm(): FormGroup {
		return this.formBuilder.group({
			descripcion: [, Validators.required],
			valor: [, Validators.required],
		});
	}
	addPrestacionForm() {
		const currentArray = this.getArray();
		if (currentArray.length < 10) {
			let newPrestacionForm = this.newPrestacionForm();
			currentArray.push(newPrestacionForm);
		}
	}

	removePrestacion(index: number) {
		const currentArray = this.getArray();
		if (currentArray.length > 1) {
			currentArray.removeAt(index);
		} else {
			currentArray.reset();
		}
	}

	onSubmit() {
		if (this.prestacionesForm.valid) {
			this.detallesBhe = this.processArrayToDetalles();
			if (this.detallesBhe && this.detallesBhe.length > 0) {
				this.getTotal();
				this.prestacionesEmitter.emit(this.detallesBhe);
				this.emisionBheService.setDetallesResumen(this.resumenBhe);
			}
		}
	}

	processArrayToDetalles(): DetalleBoletaHonorarios[] {
		let currentArray = this.getArray();
		let detallesList: DetalleBoletaHonorarios[] = [];
		if (currentArray.length > 0) {
			currentArray.controls.forEach((prestacionForm, index) => {
				let detalle = new DetalleBoletaHonorarios();
				if (prestacionForm.valid) {
					detalle.descripcion = (prestacionForm as FormGroup).controls.descripcion.value;
					detalle.valor = (prestacionForm as FormGroup).controls.valor.value;
					detallesList.push(detalle);
				}
			});
			return detallesList;
		}
		return null;
	}

	getTaxesBhe(yearOfStart: number): number {
		const currentYear = new Date().getFullYear();
		const index = currentYear - yearOfStart;

		if (index >= 0 && index < environment.withholdBheValues.length) {
			return environment.withholdBheValues[index];
		} else {
			return 0;
		}
	}

	getTotal() {
		this.totalBruto = this.detallesBhe.reduce((suma, detalle) => (suma += +detalle.valor), 0);

		let retencion = Math.round(this.totalBruto * this.porcentajeRetencion);
		if (this.currentBheDatos.retencionEmisor) {
			this.montoRetencion = 0;
		} else {
			this.montoRetencion = retencion;
		}
		this.liquido = Math.round(this.totalBruto - this.montoRetencion);
		this.resumenBhe.detalles = this.detallesBhe;
		this.resumenBhe.bruto = this.totalBruto;
		this.resumenBhe.total = this.totalBruto;
		this.resumenBhe.retenido = retencion;
		this.resumenBhe.montoRetencion = retencion;
		this.resumenBhe.liquido = this.liquido;
	}

	getArray(): FormArray {
		return this.prestacionesForm.controls.prestaciones as FormArray;
	}
}
